import React, { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toolbar } from 'primereact/toolbar';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { Dialog } from 'primereact/dialog';
import ContratService from '../services/ContratService';
import { itemPerPage, pageMaxSize } from '../baseUrls/consts';
import { Dropdown } from 'primereact/dropdown';
import TypeContratService from '../services/TypeContratService';
import VehiculeService from '../services/VehiculeService';
import TiersService from '../services/TiersService';
import { Calendar } from 'primereact/calendar';

const Contrat = () => {
    const [yesNo, setYesNo] = useState({});
    const [form, setForm] = useState({});
    
    return (
        <div>
            <div className="card">
                <Table {...{setForm, setYesNo}} />
                <Form {...{form, setYesNo}} />
                <Confirmation {...yesNo} />
            </div>
            
        </div>
    );
}

const Table = (props) => {
    const [items, setItems] = useState([]);
    const [globalFilter, setGlobalFilter] = useState(null);
    const [loading, setLoading] = useState(true);
    const {setForm, setYesNo} = props;

    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(itemPerPage);

    const onPageChange = (event) => {
        setFirst(event.first);
        setRows(event.rows);
    };

    useEffect(() => {
        loadItems();
    }, []);

    const loadItems = () => {
        ContratService.get((data, status) => {
                setLoading(false);
                if(status) setItems(data);   
            },
            {size: itemPerPage}
        );
    }

    const openNew = () => {
        setForm({
            visible: true,
            hide: ()=> setForm((prev)=>({...prev, visible: false})),
            data: null,
            setData: (data)=> setForm((prev)=>({...prev, data})),
            callback: ()=> {
                setLoading(true);
                loadItems();
            }
        });
    }

    const editItem = (item) => {
        setForm({
            visible: true,
            hide: ()=> setForm((prev)=>({...prev, visible: false})),
            data: item,
            setData: (data)=> setForm((prev)=>({...prev, data})),
            callback: ()=> {
                setLoading(true);
                loadItems();
            }
        })
    }

    const deleteItem = (item) => {
        setYesNo({   
            visible: true,
            message : "Confirmez-vous la suppression ?",
            hide: ()=> setYesNo((prev)=>({...prev, visible: false})),
            callback : ()=> {
                setLoading(true);
                ContratService.delete(item.id, (data, status)=>{
                    setLoading(false);
                    loadItems();
                });
            },
        });
    }
    
    return (
        <>
            <h5>Liste des contrats</h5>
            <Toolbar className="mb-4" 
                left={
                    <React.Fragment>
                        <div className="my-2">
                            <Button label="Nouveau" icon="pi pi-plus" className="p-button-success mr-2" 
                                onClick={openNew}/>
                            <Button label="Actualiser" icon="pi pi-refresh" className="p-button-primry mr-2" 
                                onClick={()=>{setLoading(true); loadItems()}} />
                        </div>
                    </React.Fragment>
                } 
                right={
                    <React.Fragment>
                        <span className="block mt-2 md:mt-0 p-input-icon-left">
                            <i className="pi pi-search" />
                            <InputText type="search" placeholder="Recherche..." onInput={(e) => setGlobalFilter(e.target.value)} />
                        </span>
                    </React.Fragment>
                } />
            <DataTable dataKey="id" value={items} 
                paginator rows={itemPerPage} /*first={first}  
                totalRecords={120} rowsPerPageOptions={[5, 10, 20, 30]} onPageChange={onPageChange} */
                loading={loading} globalFilter={globalFilter} 
                responsiveLayout="scroll" emptyMessage="Aucune donnée disponible.">

                <Column field="id" header="Identifiant" hidden sortable />
                <Column field="numeroContrat" header="Numéro contrat " sortable />
                <Column field="dateDebut" header="Date Début" sortable 
                    body={(item)=> new Date(item.dateDebut).toLocaleDateString()}/>
                <Column field="dateFin" header="Date fin" sortable style={{fontWeight: 'bold'}} 
                    body={(item)=> new Date(item.dateFin).toLocaleDateString()}/>
                <Column field="montant" header="Montant" sortable body={item => item.montant?.toLocaleString()} />
                <Column field="periodicite" header="Périodicité" sortable />
                <Column field="referenceContrat" header="Référence contrat" sortable />
                <Column field="typeContrat.libelleTypeContrat" header="Libellé type Contrat" sortable />
                <Column field="tiers.nom" header="Nom tiers" sortable />
                <Column body={ (selectedItem)=>
                    <div className="flex justify-content-end">
                        <Button icon="pi pi-pencil" className="p-button-rounded p-button-success mr-2" onClick={() => editItem(selectedItem)}/>
                        <Button icon="pi pi-trash" className="p-button-rounded p-button-warning mr-2" onClick={()=> deleteItem(selectedItem)}/>
                    </div>
                } />
            </DataTable>
        </>
    );
}

const Form = (props) => {
    const {visible, hide, data, setData, callback } = props.form;
    const {setYesNo} = props;
    const[loading, setLoading] = useState(false);

    const [typeContrat, setTypeContrat] = useState([]);
    const [tierses, setTierses] = useState([]);

    useEffect(()=> {
        if(!visible) return;
        TypeContratService.get((data)=> data && setTypeContrat(data), {size: pageMaxSize})
    }, [visible]);

    useEffect(()=> {
        if(!visible) return;
        TiersService.get((data)=> data && setTierses(data), {size: pageMaxSize})
    }, [visible]);
    
    const bind = (e) => {
        if(e.target.value !== undefined) {
            let value = e.target.value;
            setData({...data, [e.target.id]: value});
        }
        else if(e.checked !== undefined) {
            setData({...data, [e.target.id]: e.target.checked});
        }else{
            alert("Binding fails.")
        }
    }
    
    const submit = () => {
        setYesNo(
            {   
                visible: true,
                message : data.id ? "Confirmez-vous la modification ?" : "Confirmez-vous l'ajout ?",
                hide: ()=> setYesNo((prev)=>({...prev, visible: false})),
                callback : ()=> {
                    setLoading(true);
                    let onResponse = (data, status)=> {
                            setLoading(false);
                            if(!status) return;
                            hide();
                            callback();
                    }
                    if(data.id) ContratService.update(data, onResponse); else ContratService.add(data, onResponse);
                },
            }
        )
    
    }

    return(
        <Dialog visible={visible} style={{ width: '800px' }} header="Détails d'un contrat" modal className="p-fluid" 
            footer={
                <>
                    <Button label="Annuler" icon="pi pi-times" className="p-button-text" onClick={hide}  />
                    <Button label="Valider" icon="pi pi-check" className="p-button-text" onClick={submit} loading={loading} />
                </>
            } 
            onHide={hide}
            >  
                <div className="field" hidden>
                    <label htmlFor="id">Identifiant</label>
                    <InputText id="id" value={data && data.id} onChange={bind} />
                </div>
                <div className="field">
                    <label htmlFor="numeroContrat">Numéro contrat</label>
                    <InputText id="numeroContrat" value={data && data.numeroContrat} 
                        onChange={bind} required placeholder=" " autoFocus />
                </div>
                <div className="field">
                    <label htmlFor="dateDebut">Date début</label>
                    <InputText type="date" id="dateDebut" value={data && data.dateDebut} onChange={bind} />
                </div>
                <div className="field">
                    <label htmlFor="dateFin">Date fin</label>
                    <InputText type="date" id="dateFin" value={data && data.dateFin} onChange={bind}/>
                    
                </div>
                <div className="field">
                    <label htmlFor="montant">Montant</label>
                    <InputNumber id="montant" value={data && data.montant} 
                        onValueChange={bind} required keyfilter="num"/>
                </div>
                <div className="field">
                    <label htmlFor="periodicite">Périodicité</label>
                    <InputText id="periodicite" value={data && data.periodicite} onChange={bind} 
                        placeholder="" />
                </div>
                <div className="field">
                    <label htmlFor="referenceContrat">Référence contrat</label>
                    <InputText id="referenceContrat" value={data && data.referenceContrat} onChange={bind} 
                        placeholder="" />
                </div>
                <div className="field">
                    <label htmlFor="typeContrat">Type Contrat</label>
                    <Dropdown id="typeContrat" options={typeContrat} value={data?.typeContrat} onChange={bind}
                        optionLabel="libelleTypeContrat" /*optionValue="id"*/  
                        placeholder="Aucune sélection"/>
                </div>
                <div className="field">
                    <label htmlFor="tiers">Tiers</label>
                    <Dropdown id="tiers" options={tierses} value={data?.tiers} onChange={bind}
                        optionLabel="nom" /*optionValue="id"*/  
                        placeholder="Aucune sélection"/>
                </div>
            </Dialog>
    )
}

const Confirmation = (props) => {
    const {visible, hide, message, callback } = props;
    
    return (
        <Dialog modal visible={visible} onHide={hide} 
            header="Confirmation" style={{ width: '350px' }}
            footer={
                <>
                    <Button type="button" label="Non" icon="pi pi-times" 
                        onClick={hide} 
                        className="p-button-text" />
                    <Button type="button" label="Oui" icon="pi pi-check" 
                        onClick={() => { hide(); callback() }} 
                        className="p-button-text" autoFocus />
                </>
            }>
            <div className="flex align-items-center justify-content-center">
                <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                <span>{message != null ? message : "Voulez-vous continuer ?"}</span>
            </div>
        </Dialog>
    )
}

export default Contrat;